const vwoLoad = () => {
    window.VWO = window.VWO || [];
    VWO.visitor = VWO.visitor || function () {VWO.push(["visitor"].concat([].slice.call(arguments)))};
    VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};
};

const vwoVisitor = customerEmail => {
    VWO.visitor({ customerEmail });
};

export {
    vwoLoad,
    vwoVisitor,
};
